import React, { useState } from 'react';
import styled from 'styled-components';
import { MediaData } from '~admin/model/media-data';
import { enableFileUpload } from '~admin/view/components/ui/form/fields/media/media-overlay/helper/media-upload.helper';
import {
  MediaPickerMode,
  MediaPickerModeInner,
} from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-mode-inner.component';
import { MediaPickerModeSwitch } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-mode-switch.component';
import { MediaType } from '~client/model/media-type';
import { Button } from '~common/components/button/button.component';
import { Size } from '~common/components/button/button.helper';
import { Color } from '~common/model/basics';
import { Overlay } from '~web/view/components/layout/overlay.component';
import { DeleteIcon } from '~web/view/components/ui/icon/delete.icon';

interface Props {
  mediaType: MediaType;
  onCancel?: VoidFunction;
  onMediaSelected?: (media: MediaData | null) => void;
}

export const MediaPickerOverlay: React.FunctionComponent<Props> = ({
  mediaType,
  onCancel,
  onMediaSelected,
}) => {
  const [mode, setMode] = useState<MediaPickerMode>(MediaPickerMode.SEARCH);
  const enableUpload = enableFileUpload(mediaType);

  return (
    <StyledOverlay onCancel={onCancel}>
      <MediaPickerModeSwitch
        enabled={enableUpload}
        mode={mode}
        onModeSet={(value: MediaPickerMode): void => {
          setMode(value);
        }}
      />
      <MediaPickerModeInner
        mode={mode}
        enableUpload={enableUpload}
        mediaType={mediaType}
        onCancel={onCancel}
        onMediaSelected={onMediaSelected}
      />
      <DeleteButton
        color={Color.White}
        size={Size.Small}
        onClick={(): void => {
          onMediaSelected(null);
        }}
      >
        <DeleteIcon color={Color.Black} />
      </DeleteButton>
    </StyledOverlay>
  );
};

const StyledOverlay = styled(Overlay)`
  .overlay-scrollable-content {
    overflow: hidden;
  }
`;

const DeleteButton = styled(Button)`
  && {
    min-width: 44px;
    width: 44px;
    height: 44px;
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/media-picker-overlay.component.tsx